import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { STORE_STATUS } from '@/constants/store'
import { useImportEventsStore } from '@/stores/useImportEventsStore'

import { FilterableTable } from '../table/base'
import { getMappedTournamentsFilters, MAPPED_TOURNAMENTS_COLUMNS } from './mappedTournaments.table'

const TABLE_ID = 'mapped-tournaments-table'

export const MappedTournamentsTable = () => {
  const navigate = useNavigate()
  const { data, isLoading, isFetching, fetchData, resetState, setFilters } = useImportEventsStore(
    useShallow((state) => ({
      data: state.data,
      selectedFilters: state.filters,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching,
      fetchData: state.fetchData,
      setFilters: state.setFilters,
      resetState: state.resetState
    }))
  )

  useEffect(() => {
    fetchData()
    return resetState
  }, [])

  const mappedTournaments = useMemo(() => {
    return data.filter((tournament) => 'exchangeTournamentId' in tournament)
  }, [data])

  const tableFilters = useMemo(
    () => getMappedTournamentsFilters(mappedTournaments),
    [mappedTournaments]
  )

  return (
    <FilterableTable
      clientSideFilters
      clientSideSortAndPagination
      tableId={TABLE_ID}
      filters={tableFilters}
      columns={MAPPED_TOURNAMENTS_COLUMNS}
      onRowClick={(tournament) => {
        navigate(tournament.id)
      }}
      onFiltersChange={setFilters}
      loading={isLoading}
      fetching={isFetching}
      defaultSort={{ attribute: '$name', order: 'asc' }}
      data={mappedTournaments}
    />
  )
}
